module.exports = "/public/images/ceed3425db2ac45c6d3d59b96392ae00.svg";